package com.example.mystybag.sharedmodels.project.database

import kotlinx.serialization.Serializable

@Serializable
data class UserReservationModel(
    val id: Long,
    val userId: Long,
    val bagId: Long,
    val bagsCount: Int = 1,
    val merchantCoverPhotoUrl: String = "",
    val merchantLocationId: Long = 0L,
    val merchantId: Long = 0L, // Used to fetch location (getMerchantLocations) for pickup address etc.
    val businessCategoryId: Long? = null, // Business category ID for determining review rating categories
    val dateTimeReserved: Long,
    val dateTimeReceived: Long?,
    val dateTimeTransaction: Long?,
    val transactionReference: String,
    val status: Int, // -1= CANCELED, 0=RESERVED, 1=PAID, 3=RECEIVED, 4=PAID_TO_MERCHANT
    val menuPhotoUrls: List<String> = emptyList(), // Location menu photos (e.g. when DELIVERED_TO_CLIENT)
    val isReviewGiven: Boolean,
    val dateTimePickUpFrom: Long = 0L, // TIMESTAMPTZ as epoch ms; window start
    val dateTimePickUpTo: Long = 0L,   // TIMESTAMPTZ as epoch ms; window end
    val bagName: String? = null
)